export default __webpack_public_path__ + "static/media/maeoil.b4ca7ebb.png";